import type { FC, ReactNode } from 'react';

import classNames from 'classnames';

import iconClose from '../../assets/cross.svg';
import { ArrowLeftIcon } from '../SVGIcons/ArrowLeftIcon';

import styles from './DialogHeader.module.scss';

export type DialogHeaderProps = {
  title: ReactNode;
  onGoBack?: VoidFunction;
  onClose?: VoidFunction;
  className?: string;
  titleClassName?: string;
  titleDataTestId?: string;
  goBackBtnDataTestId?: string;
  closeBtnDataTestId?: string;
};

export const DialogHeader: FC<DialogHeaderProps> = ({
  title,
  onGoBack,
  onClose,
  className,
  titleClassName,
  titleDataTestId,
  goBackBtnDataTestId,
  closeBtnDataTestId,
}) => (
  <div className={classNames(styles.container, className)}>
    {(onGoBack || onClose) && (
      <div className={styles.buttonsWrapper}>
        {onGoBack && (
          <button className={styles.goBackButton} data-testid={goBackBtnDataTestId} onClick={onGoBack}>
            <ArrowLeftIcon />
          </button>
        )}

        {onClose && (
          <button className={styles.closeButton} data-testid={closeBtnDataTestId} onClick={onClose}>
            <img alt="iconClose" src={iconClose} />
          </button>
        )}
      </div>
    )}
    <h3 className={classNames('animation-slide-up', styles.title, titleClassName)} data-testid={titleDataTestId}>
      {title}
    </h3>
  </div>
);
